/**
 * @generated SignedSource<<9a21bd6d7fe483190928e38ebcd9a852>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItems_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_notifications" | "NavItem_notifications">;
  readonly " $fragmentType": "NavExpandingAreaItems_notifications";
};
export type NavExpandingAreaItems_notifications$key = {
  readonly " $data"?: NavExpandingAreaItems_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItems_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_notifications"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItem_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "c5dc07a45f2a169b7d2ccb6ef9e4756b";

export default node;
